var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.6C0 1.61177 1.61178 0 3.6 0H20.4C22.3882 0 24 1.61178 24 3.6V20.4C24 22.3882 22.3882 24 20.4 24H3.6C1.61177 24 0 22.3882 0 20.4V3.6Z",
    fill: "#F3EA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11367 8.74845V6.95286H9.46821V17.1H7.46384V8.74845H6.11367Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0058 14.9008C12.8966 14.1584 13.6065 13.5413 14.1354 13.0495C14.6643 12.5484 15.1051 12.0288 15.4577 11.4905C15.8104 10.9523 15.9867 10.4234 15.9867 9.90375C15.9867 9.43049 15.8753 9.05931 15.6526 8.79021C15.4299 8.5211 15.0866 8.38655 14.6226 8.38655C14.1586 8.38655 13.8013 8.5443 13.5508 8.8598C13.3003 9.16603 13.1703 9.58824 13.1611 10.1265H11.268C11.3052 9.01291 11.6346 8.16848 12.2563 7.59315C12.8873 7.01782 13.6853 6.73016 14.6504 6.73016C15.7083 6.73016 16.5202 7.01318 17.0863 7.57923C17.6523 8.136 17.9354 8.87372 17.9354 9.79239C17.9354 10.5162 17.7405 11.2075 17.3508 11.8664C16.961 12.5252 16.5156 13.1005 16.0145 13.5923C15.5134 14.0749 14.8592 14.6595 14.0519 15.3462H18.1581V16.9608H11.282V15.5132L12.0058 14.9008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge12);
export default __webpack_public_path__ + "static/media/age12.ad0511ed.svg";
export { ForwardRef as ReactComponent };